<template>
  <div>
    <OrderListItem
      v-for="item of list"
      :data="item"
      :key="item.bill_code"/>
  </div>
</template>

<script>
import OrderListItem from './OrderListItem.vue';

export default {
  name: 'OrderList',
  components: {
    OrderListItem,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.handleLoad();
  },
  activated() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      this.list = await this.$http.get('/cloud-film-api/webapi/order/get-my-bills', {
        bill_status: this.status,
      });
      // console.log(this.list);
    },
  },
};
</script>
